import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { newTypeComprasSchema } from '@/shared';
import { useCreateTypeCompras, useUpdateTypeCompras } from '@/shared/actions/erp';
import {
  CustomTextField,
  ModelStateSelect,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { TIPOCOMPRAS } from '@/shared/interfaces';

const returnUrlTypeCompras = '/compras/tipo-compras';

export interface SaveTypeComprasInterface {
  titlePage: string;
  editTypeCompras?: TIPOCOMPRAS;
}

type SaveFormData = {
  nombre: string;
  estado: boolean;
};

const SaveTypeCompras: React.FC<SaveTypeComprasInterface> = ({ titlePage, editTypeCompras }) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createTypeComprasMutation = useCreateTypeCompras({navigate, returnUrl:returnUrlTypeCompras});
  const updateTypeComprasMutation = useUpdateTypeCompras({navigate, returnUrl:returnUrlTypeCompras});

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newTypeComprasSchema),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editTypeCompras?.id_tipo_compra) {
      return updateTypeComprasMutation.mutate({
        id: editTypeCompras.id_tipo_compra,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createTypeComprasMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editTypeCompras) {
      setShrink(true);
      reset({
        nombre: editTypeCompras.nombre,
        estado: !!editTypeCompras.estado ? '1' : '0',
      } as any);
    }
  }, [editTypeCompras]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlTypeCompras);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
                name="nombre"
                label="Nombre"
                control={form.control}
                defaultValue={form.getValues().nombre || ""}
                error={errors.nombre}
                helperText={errors.nombre?.message}
                shrink={shrink}
              />
      {/* ====== state ====== */}
      <ModelStateSelect
        defaultValue={form.getValues().estado || ''}
        register={register('estado')}
        error={errors.estado}
        helperText={errors.estado?.message}
      />
    </SingleFormBoxScene>
  );
};

export default SaveTypeCompras;
